import ViewList from './view/view_list.vue'
import Search from './module/search.vue'
import SearchItem from './module/search_item.vue'
import Operate from './module/operate.vue'

import CustomForm from './module/custom_form.vue'
import CustomDetail from './module/custom_detail.vue'
import CustomTable from './module/custom_table.vue'

import DocFlow from './module/doc_flow.vue'
import DocBase from './module/doc_base.vue'
import DocContent from './module/doc_content.vue'
import DocLog from './module/doc_log.vue'
import DocHandle from './module/doc_handle.vue'

import memberIcon from './module/member_icon.vue'

import Tips from './public/tips.vue'
import State from './public/state.vue'
import Field from './public/field.vue'
import Tags from './public/tags.vue'
import FileList from './public/file_list.vue'
import ProcessRate from './public/process_rate.vue'
import InfoCard from './public/info_card.vue'
import SelectOption from './public/select_option.vue'
import OrderLink from './public/order_link.vue'
import Location from './public/location.vue'
import Map from './public/map.vue'

import ScrollList from './public/scroll_list.vue'

var comps = [
	ViewList,
	Search,
	SearchItem,
	Operate,
	
	CustomForm,
	CustomDetail,
	CustomTable,

	DocFlow,
	DocBase,
	DocContent,
	DocLog,
	DocHandle,

	memberIcon,

	Tips,
	State,
	Field,
	Tags,
	FileList,
	ProcessRate,
	InfoCard,
	SelectOption,
	OrderLink,
	Location,
	Map,

	ScrollList
]

// 导出组件
export default {
	install: function(Vue) {
		comps.forEach(comp => {
			Vue.component(comp.name, comp);
		})
    }
}